import { createClientApp } from './app/bootstrap.js';

const app = createClientApp();

function init() {
  app.init();
}

if (typeof window !== 'undefined') {
  window.ApTransitClient = app;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

export { app, init };
